import React from 'react';
import Alert from '../assets/images/Alert.svg';

export default () => {
  return <img src={Alert} alt="" />;
};
